<draggable-container [prefix]="data.prefix">
  <div class="d-flex justify-content-center">
    <label [for]="data.prefix+'courseImage'" class="btn btn-levelab btn-outline-levelab me-1">

      <div *ngIf="!!data.src" class="mb-4 text-center">
        <img class="image-preview" width="40%" [src]="data.src" [alt]="data.alt">
      </div>
      <span>Seleccionar imagen</span>
    </label>

      <input type="file" name="image" accept="image/*" class="form-control mb-1"
      [id]="data.prefix+'courseImage'" required="required" hidden (change)="onFileSelected($event)">
  </div>
  <div class="text-center mt-1">
    <small *ngIf="errorMessage" class="text-danger"><i class="bi bi-x-circle me-1"></i>{{ errorMessage }}</small>
  </div>
  <label [for]="data.prefix+'ImageAlt'">
    <span>Alt</span>
  </label>
  <input type="text" name="alt"class="form-control mb-1"
      [id]="data.prefix+'ImageAlt'" [(ngModel)]="data.alt">

</draggable-container>
